/* eslint-disable react/prop-types */
import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";

export default function WaitingRecordingPopup(props) {
  const { open, data } = props;
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modelChat"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className="modelWaitingRecording">
            <div className="text-center">
              <span className="mb-4">
                <VideocamOffIcon color="action" style={{ fontSize: "100px" }} />
              </span>
              <h4 className="fw-bold mb-3">
                Kindly wait until the recording is ready before starting the
                lecture
              </h4>
              <h5>
                Recording starts in{" "}
                <p className="fs-1 fw-bold m-0 text-danger">{data}</p>
              </h5>
              <p className="m-0">
                The popup will auto-hide when recording starts.
              </p>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
